import { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { SHOPLINE_NAVIGATION } from 'routes/paths';
import { isValidToken } from 'utils/jwt';
import useConnector from 'hooks/useConnector';
import usePortalId from 'hooks/usePortalId';

type GuestGuardProps = {
  children?: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const portalId = usePortalId();
  const { isAuthenticated } = useAuth();
  const accessToken = sessionStorage.getItem('accessToken');
  const { hubspotOnboarded } = useConnector();

  if (!isAuthenticated || !isValidToken(accessToken ?? '')) {
    throw new Error('Invalid Token');
  }

  if (hubspotOnboarded) {
    return <Navigate to={SHOPLINE_NAVIGATION.general.home(portalId)} />;
  }

  return (
    <>
      {children}
      <Outlet />
    </>
  );
}
